function formattedCurrencyInteger() {
    return {
        componentName: 'formattedCurrencyInteger',
        variants: {
            dynamic: {}
        }
    };
}

export { formattedCurrencyInteger as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybWF0dGVkQ3VycmVuY3lJbnRlZ2VyLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvdGhlbWUvY29tcG9uZW50cy9mb3JtYXR0ZWRDdXJyZW5jeS9mb3JtYXR0ZWRDdXJyZW5jeUludGVnZXIudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgQ29tcG9uZW50U3R5bGUgfSBmcm9tICcuLi8uLi90eXBlcyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGZvcm1hdHRlZEN1cnJlbmN5SW50ZWdlcigpOiBDb21wb25lbnRTdHlsZSB7XG4gIHJldHVybiB7XG4gICAgY29tcG9uZW50TmFtZTogJ2Zvcm1hdHRlZEN1cnJlbmN5SW50ZWdlcicsXG4gICAgdmFyaWFudHM6IHtcbiAgICAgIGR5bmFtaWM6IHt9XG4gICAgfVxuICB9O1xufVxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVjLFNBQVUsd0JBQXdCLEdBQUE7SUFDOUMsT0FBTztBQUNMLFFBQUEsYUFBYSxFQUFFLDBCQUEwQjtBQUN6QyxRQUFBLFFBQVEsRUFBRTtBQUNSLFlBQUEsT0FBTyxFQUFFO0FBQ1Y7S0FDRjtBQUNIOzs7OyJ9
